import mixin from "@/mixin";
import { MessageBox, Message } from "element-ui";

const state = {
    customList: "",
    selectedInputType: "",
};

const mutations = {
    SET_CUSTOM_FORM: (state, customForm) => {
        state.customList = customForm;
    },
    SET_SELECTED_INPUT_TYPE: (state, selectedInfo) => {
        state.selectedInputType = selectedInfo;
    },
    ADD_INPUT_TYPE: (state, inputType) => {
        state.customList.push(inputType);
    },
    REMOVE_FORM_INPUT_KEY: (state, removeInfo) => {
        delete state.customList[removeInfo.index][removeInfo.key]; 
    },
    REMOVE_VALUE: (state, removeIndex) => {
        state.customList[removeIndex] = "";
    },
    UPDATE_VALUE: (state, updateInfo) => {
        var { key, value, index } = updateInfo;
        state.customList[index][key] = value;

        if (key == "name") {
            var d = new Date();
            var time = d.getTime();
            var myDataName = state.customList[index].name.replace(/ /g,"_");
            var clean_dataName = myDataName.replace(/[^\w\s]/gi, "");   //clean special character just in case
            state.customList[index].dataName = clean_dataName + "_" + time;
        }
    },
    CLEAR_FORM_LIST: (state) => {
        state.customList = [];
        state.selectedInputType = "";
    },
    RENAME_RULE_DATANAMES: (state) => {
        state.customList.forEach(custom_list => {
            if (custom_list.customFieldVisibilityRules) {
                custom_list.customFieldVisibilityRules.forEach(vis_rule => {
                    if (vis_rule.formId == custom_list.formId) {
                        vis_rule.dataName = custom_list.dataName;
                    }
                }); 
            }
        });
    }
};

const actions = {
    getCustomList({ commit, state }) {
        try {
            var arr = [...state.customList];
            let isError = false;
            arr.forEach((custom_list, index) => {
                custom_list.sequence = index + 1;

                const { name, code, inputSubjectTypeId, customFieldVisibilityRules, customFieldRequirementRules } = custom_list;
                if (code == "SUBJECT_BARCODE" || code == "MULTI_SUBJECT_BARCODE" || code == "SUBJECT_LIST" || code == "EXTERNAL_BARCODE" || code == "MULTI_EXTERNAL_BARCODE" || code == "CHILD_COUNT" || code == "MULTI_CHILD_BARCODE" || code == "CHILD_BARCODE" || code == "CHILD_LIST" ) {
                    if (!inputSubjectTypeId) {
                        Message({
                            message: `Subject Type is not chosen in ${name} input field`,
                            type: "error",
                            duration: 5 * 1000
                        });
                        isError = true;
                    }
                }
                if (customFieldVisibilityRules) {
                    customFieldVisibilityRules.forEach(vis_rule => {
                        arr.forEach(list => {
                            if (vis_rule.formId == list.formId) {
                                vis_rule.dataName = list.dataName;
                            }
                        });
                    }); 
                }
                if (customFieldRequirementRules) {
                    customFieldRequirementRules.forEach(require_rule => {
                        arr.forEach(list => {
                            if (require_rule.formId == list.formId) {
                                require_rule.dataName = list.dataName;
                            }
                        });
                    }); 
                }
            });
            if (isError) {
                throw "exit";
            }
            else return arr;
        }
        catch {
            console.log("error");
        }
    },
    setCustomFormList({ commit }, customForm) {
        commit("SET_CUSTOM_FORM", customForm);
    },
    setSelectedInfo({ commit }, selectedInfo) {
        commit("SET_SELECTED_INPUT_TYPE", selectedInfo);
    },
    addInputType({ commit }, inputType) {
        commit("ADD_INPUT_TYPE", inputType);
    },
    removeFormKey({ commit }, removeInfo) {
        commit("REMOVE_FORM_INPUT_KEY", removeInfo);
    },
    removeOneValueFiler({ commit }, removeIndex) {
        commit("REMOVE_VALUE", removeIndex);
    },
    updateFormList({ commit }, updateInfo) {
        commit("UPDATE_VALUE", updateInfo);
    },
    clearFormList({ commit }) {
        commit("CLEAR_FORM_LIST");
    },
    renameRulesDataname({ commit }) {
        commit("RENAME_RULE_DATANAMES");
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/custom_form.js